var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSigaPitchedRoof(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 643.96 404.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 0.45,
    width: 643.05,
    height: 403.97,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.97,105.6H1.79v23.46h639.18v-23.46Z",
    fill: "#234c6f",
    isolation: "isolate",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79,129.07h639.18",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.99
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.28,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.72,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.17,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.61,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.94,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.38,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.83,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.27,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.72,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.16,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.61,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.05,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.97,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.43,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.88,129.07l16.95-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.35,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.8,129.07l16.95-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.26,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.72,129.07l16.95-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.18,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.64,129.07l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.08,129.17l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.53,129.17l16.94-22.52",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.02,349.73H28.59v12.5h44.44v-12.5Z",
    fill: "#e10e16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "#e10e16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.17,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "#e10e16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.23,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "#e10e16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.3,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "#e10e16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.37,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "#e10e16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.44,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "#e10e16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.46,349.76H1.79v12.48h640.66v-12.48Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.78,93.1H24.08v12.5h44.69v-12.5Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,93.1h-44.69v12.5h44.69v-12.5Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.98,93.1h-44.69v12.5h44.69v-12.5Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.57,93.1h-44.69v12.5h44.69v-12.5Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.17,93.1h-44.69v12.5h44.69v-12.5Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.78,93.1h-44.7v12.5h44.7v-12.5Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.37,93.1h-44.69v12.5h44.69v-12.5Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.46,93.1H1.79v12.5h640.66v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.78,93.1H24.08v12.5h44.69v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,93.1h-44.69v12.5h44.69v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.98,93.1h-44.69v12.5h44.69v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.57,93.1h-44.69v12.5h44.69v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.17,93.1h-44.69v12.5h44.69v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.78,93.1h-44.7v12.5h44.7v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.37,93.1h-44.69v12.5h44.69v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.02,349.73H28.59v12.5h44.44v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.17,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.23,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.3,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.37,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.44,349.73h-44.44v12.5h44.44v-12.5Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.46,388.87H1.79v14.49h640.66v-14.49Z",
    fill: "#234c6f",
    isolation: "isolate",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.46,388.87H1.79v14.49h640.66v-14.49Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3,393.83l2.46-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.12,400.67l-2.25-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.29,400h-3.49",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.29,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.59,395.65l2.44.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,394.66l2.47,2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.68,401.49l2.46-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.68,393.99l-1.24-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,393.83l2.46-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.24,400.67l-2.26-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.75,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.41,400h-3.49",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.41,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,395.65l2.45.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62,394.66l2.46,2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8,401.49l2.46-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8,393.99l-1.24-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.54,393.83l2.46-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.36,400.67l-2.26-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.87,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.53,400h-3.49",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.54,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.82,395.65l2.45.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.74,394.66l2.46,2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.92,401.49l2.46-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.92,393.99l-1.24-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,393.83l2.46-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.49,400.67l-2.26-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.66,400h-3.49",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.66,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.95,395.65l2.45.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.87,394.66l2.46,2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.04,401.49l2.47-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.04,393.99l-1.23-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.38,393.83l2.46-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.2,400.67l-2.26-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.71,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.37,400h-3.49",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.37,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,395.65l2.44.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.58,394.66l2.46,2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.76,401.49l2.46-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.76,393.99l-1.24-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.51,393.83l2.46-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.33,400.67l-2.26-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.83,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.5,400h-3.49",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.5,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.79,395.65l2.45.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.71,394.66l2.46,2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.89,401.49l2.46-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.89,393.99l-1.24-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.63,393.83l2.46-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.45,400.67l-2.26-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.96,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.62,400h-3.49",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.62,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91,395.65l2.45.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.83,394.66l2.46,2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,401.49l2.47-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,393.99l-1.23-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.74,393.83l2.47-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.57,400.67l-2.26-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.08,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.73,400h-3.48",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.73,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.03,395.65l2.45.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.95,394.66l2.46,2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.12,401.49l2.47-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.12,393.99l-1.23-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.8,393.83l2.47-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.62,400.67l-2.25-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.13,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.79,400h-3.49",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.79,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.08,395.65l2.44.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,394.66l2.47,2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.18,401.49l2.47-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.18,393.99l-1.23-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.92,393.83l2.47-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.74,400.67l-2.25-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.25,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.91,400h-3.49",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.91,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.21,395.65l2.44.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.12,394.66l2.47,2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.3,401.49l2.46-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.3,393.99l-1.23-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.04,393.83l2.47-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.86,400.67l-2.25-2.47",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.37,400.67l-2.22,1.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.03,400h-3.49",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.03,390.34l-.15,3.34",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.33,395.65l2.44.7",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.42,401.49l2.46-2.25",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.42,393.99l-1.23-2.23",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.27,349.4c-19.59,0-35.47-15.92-35.47-35.55,0-2.86.34-5.63.61-7.88l33.9-132.62c.64-2.66.97-5.43.97-8.29,0-19.63-15.88-35.55-35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.27,349.4c19.59,0,35.47-15.92,35.47-35.55,0-2.86-.34-5.63-.97-8.29l-33.54-132.21c-.64-2.66-.97-5.43-.97-8.29,0-19.63,15.88-35.55,35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.68,129.51c19.59,0,35.47,15.92,35.47,35.55,0,2.86-.34,5.63-.97,8.29",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.21,349.4c19.59,0,35.47-15.92,35.47-35.55,0-2.86-.34-5.63-.61-7.88l-33.9-132.62c-.64-2.66-.97-5.43-.97-8.29,0-19.63,15.88-35.55,35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.21,349.4c-19.59,0-35.47-15.92-35.47-35.55,0-2.86.34-5.63.97-8.29l33.54-132.21c.64-2.66.97-5.43.97-8.29,0-19.63-15.88-35.55-35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.16,349.4c-19.59,0-35.47-15.92-35.47-35.55,0-2.86.34-5.63.97-8.29l33.54-132.21",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.63,129.51c-19.59,0-35.47,15.92-35.47,35.55,0,2.86.34,5.63.97,8.29",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,349.4c-19.59,0-35.47-15.92-35.47-35.55,0-2.86.34-5.63.61-7.88l33.9-132.62c.64-2.66.97-5.43.97-8.29,0-19.63-15.88-35.55-35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,349.4c19.59,0,35.47-15.92,35.47-35.55,0-2.86-.34-5.63-.97-8.29l-33.54-132.21c-.63-2.66-.97-5.43-.97-8.29,0-19.63,15.88-35.55,35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.16,349.4c19.59,0,35.47-15.92,35.47-35.55,0-2.86-.34-5.63-.97-8.29l-33.54-132.21",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.52,129.51c19.59,0,35.47,15.92,35.47,35.55,0,2.86-.34,5.63-.97,8.29",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.05,349.4c19.59,0,35.47-15.92,35.47-35.55,0-2.86-.33-5.63-.61-7.88l-33.9-132.62c-.64-2.66-.97-5.43-.97-8.29,0-19.63,15.88-35.55,35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.05,349.4c-19.59,0-35.47-15.92-35.47-35.55,0-2.86.34-5.63.97-8.29l33.54-132.21c.63-2.66.97-5.43.97-8.29,0-19.63-15.88-35.55-35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,349.4c-19.59,0-35.47-15.92-35.47-35.55,0-2.86.34-5.63.97-8.29l33.54-132.21",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.47,129.51c-19.59,0-35.47,15.92-35.47,35.55,0,2.86.34,5.63.97,8.29",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.94,349.4c-19.59,0-35.47-15.92-35.47-35.55,0-2.86.34-5.63.61-7.88l33.9-132.62c.64-2.66.97-5.43.97-8.29,0-19.63-15.88-35.55-35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.94,349.4c19.59,0,35.47-15.92,35.47-35.55,0-2.86-.34-5.63-.97-8.29l-33.54-132.21c-.64-2.66-.97-5.43-.97-8.29,0-19.63,15.88-35.55,35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.99,349.4c19.59,0,35.47-15.92,35.47-35.55,0-2.86-.34-5.63-.97-8.29l-33.54-132.21",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.36,129.51c19.59,0,35.47,15.92,35.47,35.55,0,2.86-.33,5.63-.97,8.29",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.89,349.4c19.59,0,35.47-15.92,35.47-35.55,0-2.86-.33-5.63-.61-7.88l-33.9-132.62c-.64-2.66-.97-5.43-.97-8.29,0-19.63,15.88-35.55,35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.89,349.4c-19.59,0-35.47-15.92-35.47-35.55,0-2.86.33-5.63.97-8.29l33.54-132.21c.64-2.66.97-5.43.97-8.29,0-19.63-15.88-35.55-35.47-35.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.83,349.4c-19.59,0-35.47-15.92-35.47-35.55,0-2.86.34-5.63.97-8.29l33.54-132.21",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.31,129.51c-19.59,0-35.47,15.92-35.47,35.55,0,2.86.34,5.63.97,8.29",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.83,349.4c19.59,0,35.47-15.92,35.47-35.55,0-2.86-.33-5.63-.97-8.29l-33.54-132.21",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.15,66.48h-50.26v26.62h50.26v-26.62Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.89,66.48l50.26,26.61",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.89,93.1l50.26-26.61",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.96,66.48h-50.26v26.62h50.26v-26.62Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.7,66.48l50.26,26.61",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.7,93.1l50.26-26.61",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.15,362.25h-50.26v26.62h50.26v-26.62Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.89,362.25l50.26,26.61",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.89,388.87l50.26-26.61",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.96,362.25h-50.26v26.62h50.26v-26.62Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.7,362.25l50.26,26.61",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.7,388.87l50.26-26.61",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.17,33.75H1.5v32.73h640.67v-32.73Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.34,129.17h-74.31v219.55h74.31v-219.55Z",
    fill: "#fff",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.03,129.17l74.31,219.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.32,348.36l75.02-219.19",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.54,129.17H36.23v219.55h74.31v-219.55Z",
    fill: "#fff",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.23,129.17l74.31,219.55",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.51,348.36l75.02-219.19",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,1.84h46.91c.27,1.2,2.35,9.8,10.89,14.19,1.15.6,8.2,4.07,16.32,1.12,10.54-3.82,13.13-14.91,13.29-15.65,14.67.11,29.34.23,44,.34,0,0,3.04,5.29,2.84,7.52-.2,2.19-2.76,12.64-2.85,13.02h-4.75l-2.23-8.34h-7.77l-2.67,8.35h-7.17l-2.33-8.35h-7.45l-7.22,19.71h-8.72l-1.22-5.29c.07,0-13.4,1.3-19.31.54-5.39-.69-12.48-3.83-20.21-14.35H1.5",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.12,9.36c-.2,2.19-2.76,12.64-2.85,13.02h-4.75l-2.23-8.34h-7.77l-2.67,8.35h-7.17l-2.33-8.35h-7.45l-7.22,19.71h-8.72l-1.22-5.29c.07,0-13.4,1.3-19.31.54-5.39-.69-12.48-3.83-20.21-14.35h-40.56c-2.33,3.23-6.69,8.3-13.78,11.85-12.84,6.43-25.15,3.13-28.2,2.21-5.3-1.6-9.25-4.05-11.76-5.89-1.69,3.64-3.38,7.28-5.07,10.92h-44.34l.16-.99,2.88-18.72h6.09l2.33,8.35h7.16l2.68-8.35h6.08l2.24,8.33h7.48s3.4-9.56,3.19-20.53h11.35c.24,1.21,2.08,9.79,10.15,14.02,7.75,4.07,15.46.97,18.25-.14,9.25-3.71,13.29-11.71,14.3-13.88h55.94c.27,1.2,2.35,9.8,10.89,14.19,1.15.6,8.19,4.07,16.32,1.12,10.54-3.82,13.13-14.91,13.29-15.65,14.67.11,29.34.23,44,.34,0,0,3.04,5.29,2.84,7.52Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.5,9.36c-.2,2.19-2.76,12.64-2.85,13.02h-4.75l-2.23-8.34h-7.77l-2.67,8.35h-7.17l-2.33-8.35h-7.45l-7.22,19.71h-8.72l-1.22-5.29c.07,0-13.4,1.3-19.31.54-5.39-.69-12.48-3.83-20.21-14.35h-40.56c-2.33,3.23-6.69,8.3-13.79,11.85-12.84,6.43-25.15,3.13-28.2,2.21-5.3-1.6-9.25-4.05-11.76-5.89-1.69,3.64-3.38,7.28-5.07,10.92h-44.34l.16-.99,2.88-18.72h6.09l2.33,8.35h7.16l2.68-8.35h6.08l2.24,8.33h7.48s3.4-9.56,3.19-20.53h11.35c.24,1.21,2.08,9.79,10.14,14.02,7.75,4.07,15.46.97,18.25-.14,9.25-3.71,13.29-11.71,14.29-13.88h55.94c.27,1.2,2.35,9.8,10.89,14.19,1.15.6,8.2,4.07,16.32,1.12,10.54-3.82,13.13-14.91,13.29-15.65,14.67.11,29.34.23,44,.34,0,0,3.04,5.29,2.84,7.52Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.17,14.65h-36.75c-2.33,3.23-6.69,8.3-13.78,11.85-12.84,6.43-25.15,3.13-28.2,2.21-5.3-1.6-9.25-4.05-11.76-5.89-1.69,3.64-3.38,7.28-5.07,10.92h-44.34l.16-.99,2.88-18.72h6.09l2.33,8.35h7.16l2.68-8.35h6.08l2.24,8.33h7.48s3.4-9.56,3.19-20.53h11.35c.24,1.21,2.08,9.79,10.15,14.02,7.75,4.07,15.46.97,18.25-.14,9.25-3.71,13.29-11.71,14.3-13.88h45.57",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.72,47.7h-27.24l-4.19-13.95h35.63l-4.2,13.95Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.95,47.7h-27.24l-4.2-13.95h35.63l-4.19,13.95Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.24,47.7h-27.24l-4.19-13.95h35.63l-4.2,13.95Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.95,47.7h-27.24l-4.19-13.95h35.63l-4.2,13.95Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.67,47.7h-27.24l-4.2-13.95h35.63l-4.19,13.95Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.92,47.7h-27.24l-4.19-13.95h35.63l-4.2,13.95Z",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigaPitchedRoof);
export default __webpack_public_path__ + "static/media/sigaPitchedRoof.f940190c59605406da2b48e52b2da5f4.svg";
export { ForwardRef as ReactComponent };